import { useContractQuery } from "@amtana/browser";
import type { QueryResult } from "@amtana/browser";
import { featureFlagTrpcContract } from "@amtana/feature-flag-contract";
import type { ResolveAllOutput } from "@amtana/feature-flag-contract";

// ADR-006 §7: the active organization's flags, for every browser module. The low-level
// read `resolveAll` door; the feature-flag module's own browser half (`withFlagsSource`)
// composes it with the active organization id into the framework's flags source, which
// is where `useFlag`/`useFlagValues` (@amtana/browser) answer from. Parameterized rather
// than reading the organization itself: a client stays its own contract's data door,
// nothing else (`amtana/package-boundaries`).

export function useResolvedFlags(organizationId: string | undefined): QueryResult<ResolveAllOutput> {
  return useContractQuery(featureFlagTrpcContract, "resolveAll", {
    input: { organizationId: organizationId ?? "" },
    enabled: organizationId !== undefined,
  });
}
